@use "./inlineReference";

.code {
  @include inlineReference.reference;
  display: inline-block;
  border: 0;
  padding: 0.1em 0.3em;
  max-width: 100%;
  gap: 0;
  background: var(--color-inline-code-background);
  color: var(--color-inline-code-foreground);
  white-space: normal;

  // Light scheme: the light theme's color from the token's `hl<n>` class (CodePalette.ts).
  > span {
    color: var(--hl);
    font-size: inherit;
    line-height: inherit;
  }
}

:global(.dark) .code > span,
:global([data-theme="dark"]) .code > span {
  // The code theme's color from the token's `h<n>` class. Foreground tokens have none, and an
  // unset variable leaves them the code's own color.
  color: var(--h);
}
